<template>
  <v-app>
    <v-navigation-drawer app v-model="drawer" width="280" class="sidebar-drawer">
      <v-list nav class="sidebar-list" density="compact">
        <v-list-item class="logo-item justify-center" v-if="showLogo">
          <div class="logo-avatar">
            <img src="@/assets/lg.png" alt="Speedy Logo" @error="handleImageError" @load="handleImageLoad" />
          </div>
        </v-list-item>
        <v-divider class="logo-divider" v-if="showLogo"></v-divider>
        <v-list-item
          prepend-icon="mdi-view-dashboard"
          title="Dashboard"
          to="/dashboard"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-bell-outline"
          to="/notifications"
          title="Notifications"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-plus-circle-multiple-outline"
          title="Investments"
          to="/packages"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-format-list-bulleted"
          title="Transactions"
          to="/transactions"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-clipboard-text-clock"
          title="Withdrawal"
          to="/withdrawal"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-bank-transfer"
          title="Loan Management"
          to="/loans"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-file-document-edit"
          title="Loan Products"
          to="/loan-products"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-chart-line"
          title="Financial Analytics"
          to="/financial-analytics"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-cash-multiple"
          title="Daily Financials"
          to="/daily-financials"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-account-group"
          title="Users Management"
          to="/users"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-credit-card-multiple"
          title="Card Management"
          to="/cards"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-piggy-bank"
          title="Fixed Deposits"
          to="/fixed-deposits"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-monitor-cellphone"
          title="Advertisements"
          to="/advertisements"
          exact
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-shield-lock-outline"
          title="Account Security"
          to="/account"
          exact
        ></v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="red-darken-4">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Dashboard</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="logOutRequest" color="white">
        <v-icon left>mdi-logout</v-icon> Logout</v-btn
      >
    </v-app-bar>

    <v-main class="app">
      <v-container fluid class="app">
        <router-view></router-view>
        <!--snackbar -->
        <v-snackbar v-model="snackbar.show" :timeout="snackbar.timeout">
          {{ snackbar.message }}
        </v-snackbar>

        <!--prompt-->
        <v-dialog v-model="RequestDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="text-button">
              {{ prompt }}
            </v-card-title>
            <v-card-text class="text-button"
              >Do You Want To Log Out</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="RequestDialog = false">
                No
              </v-btn>
              <v-btn
                :loading="isLoading"
                color="green darken-1"
                text
                @click="logOut"
              >
                Yes
                <template v-slot:loader>
                  <v-progress-circular indeterminate color="green" size="20" />
                </template>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
  </v-app>

</template>

<script setup>
/* eslint-disable */
import { ref, reactive } from "vue";
import axios from "@/utils/axiosConfig";
import { useRouter } from "vue-router";

const RequestDialog = ref(false);
const drawer = ref(true);
const router = useRouter();
const isLoading = ref(false);
const prompt = ref("Logout");
const showLogo = ref(true);

const snackbar = reactive({
  show: false,
  message: "",
  timeout: 3000,
});

const logOutRequest = () => {
  RequestDialog.value = true;
};

const handleImageError = () => {
  // Hide the logo if image fails to load
  showLogo.value = false;
};

const handleImageLoad = () => {
  // Ensure logo is shown if image loads successfully
  showLogo.value = true;
};

const logOut = async () => {
  isLoading.value = true;
  try {
    await axios.post("/admin/logout");
  } catch (error) {
    // Even if logout API fails, clear local session
    console.warn('Logout API failed, clearing session anyway:', error);
  } finally {
    localStorage.removeItem('token');
    isLoading.value = false;
    router.push({ name: "Login" });
  }
};
</script>

<style scoped>
.title {
  font-size: 24px;
  font-weight: bold;
  padding: 16px 0;
  text-align: center;
}

.v-list-item--nav .v-list-item-title {
  font-size: 1rem;
}

.v-navigation-drawer {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

.v-navigation-drawer::before {
  display: none !important;
}

.v-navigation-drawer .v-list {
  padding: 0 !important;
  margin: 0 !important;
}

.v-navigation-drawer .v-list-item {
  min-height: 48px;
  padding-top: 0 !important;
  margin-top: 0 !important;
}

.v-navigation-drawer .v-list-item:first-child {
  margin-top: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 8px !important;
}

.sidebar-drawer {
  padding-top: 0 !important;
  margin-top: 0 !important;
  top: 0 !important;
}

.sidebar-drawer .v-navigation-drawer__content {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

.sidebar-list .v-list-item:first-child:not(.logo-item),
.sidebar-list .logo-item {
  padding: 4px 0 !important;
  margin: 0 !important;
  min-height: auto !important;
}

/* We cannot use :has() due to CSS minifier crashes. Handled via Vue template logic if needed. */

.sidebar-list .logo-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto !important;
}

/* Replaced :has() with direct element styling or Vue conditions */

.sidebar-list .logo-avatar {
  margin: 0 auto !important;
  padding: 0 !important;
  flex-shrink: 0;
  width: 120px !important;
  height: 120px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-list .logo-avatar img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 0;
  margin: 0;
}

/* Replaced :has() with direct element styling or Vue conditions */

.sidebar-list .logo-divider {
  margin: 4px 0 !important;
}

.sidebar-list {
  padding: 0 !important;
  margin: 0 !important;
  padding-top: 0 !important;
  margin-top: 0 !important;
}

.sidebar-list .v-divider {
  margin: 8px 0 !important;
}

.sidebar-list .v-list-item:not(:first-child) {
  margin-top: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.speedy-theme {
  color: #d13520;
  font-weight: 900;
}
</style>
